import React from "react";
import Card from "../Card/Card";
// import HeartEmoji from "../../img/heartemoji.png";
import Resume from "./Resume.pdf";
import Reroar2 from "../../img/Reroar2.jpg";
import aryan from "../../img/aryan.jpg";
import mmmut from "../../img/mmmut.jfif" ;
import "./Services.css";

const Services = () => {
  return (
    <div className="Intro" id="Services">
      <div className="title">
        <h1>About Me</h1>
        <span>My Introduction</span>
      </div>

      <div className="services">
        {/* left side */}
        <img className="Reroar2" src={Reroar2} alt="" />
        <div className="awesome">
          {/* <span>My Awesome</span>
          <span>services</span> */}
          <span>
            Enthusiastic and task-driven web developer with 4+ projects <br/>for
            gaining MERN-stack development experience and becoming adept at
            <br/>contributing to a highly collaborative work environment and finding
            solutions.<br/> Good knowledge of creating faster, user-friendly, and
            efficient websites.
          </span>
          <a href={Resume} download>
            <button className="button s-button">Download CV</button>
          </a>
          <div
            className="blur"
            style={{ background: "rgb(238 210 255)", left: "35rem" }}
          ></div>
          <div
            className="blur"
            style={{ background: "rgb(238 210 255)",top: '34rem', left: "2rem" }}
          ></div>
          <div
            className="blur"
            style={{
              background: "#C1F5FF",
              top: "-12rem",
              left: "-3rem",
              height: "11rem",
            }}
          ></div>
          <div
            className="blur"
            style={{
              background: "#C1F5FF",
              top: "50rem",
              left: "30rem",
              height: "11rem",
            }}
          ></div>
        </div>

        {/* right side */}
        <div className="cards">
          <div className="carda" >
            <Card
              emoji={aryan}
              heading={"Intermediate | PCM"}
              detail1={"The Aryan International School, Varanasi, Uttar Pradesh"}
              detail2={"2017-2019 | Completed"}
            />
          </div>
          <div className="cardb" >
            <Card
              emoji={mmmut}
              heading={"Bachelor of Technology in Electronics and Communication Engineering"}
              detail1={"Madan Mohan Malaviya University of Technology, Gorakhpur, Uttar Pradesh"}
              detail2 = {"2020 - 2024 | Pursuing"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
